export default "__VITE_ASSET__DnqfTpMo__"